import React from 'react';
import clsx from 'clsx';
import { getArchiveIcon } from '@isyc-react/archives/view/tools';
import { Slug } from '@isyc-react/animation/modules/base/trail';
import { DocumentalValidationCode } from '@isyc-react/types';
import { DocGroupCardFile } from './doc-group-card-file.component';
import { DocGroupCompleted } from './doc-group-completed.component';
const AcceptedFormat = props => {
    const { ext, children } = props;
    const classes = getArchiveIcon(ext);
    return (React.createElement("div", { className: 'd-flex align-items-center border-2 rounded-lg px-2 shadow-sm mx-2 bg-white opacity-80' },
        React.createElement("i", { className: clsx(classes.icon, 'font-size-22 me-2') }),
        React.createElement("div", { className: 'font-size-15' }, children)));
};
export const DossierDocuments = props => {
    const { docs, onUpload, businessUnitId } = props;
    const nPending = React.useMemo(() => {
        if (docs) {
            const nDocGroupPending = docs.pending.reduce((acc, p) => acc + p.requests.length, 0);
            return nDocGroupPending;
        }
        return 0;
    }, [docs]);
    const nRealPending = React.useMemo(() => {
        if (docs) {
            const nDocGroupPending = docs.pending
                .filter(doc => doc.validation !== DocumentalValidationCode.NONE)
                .reduce((acc, p) => acc + p.requests.length, 0);
            return nDocGroupPending;
        }
        return 0;
    }, [docs]);
    const nCompleted = React.useMemo(() => {
        if (docs) {
            return docs.completed.reduce((acc, c) => acc + c.requests.length, 0);
        }
        return 0;
    }, [docs]);
    const nTotal = nPending + nCompleted;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'px-5 px-md-0' },
            React.createElement("div", { className: 'container shadow p-0 bg-white mt-4 mb-4' },
                React.createElement("h2", { className: 'bg-primary text-center text-light py-3' }, "Fichiers requis"),
                React.createElement("div", { className: 'p-3' },
                    React.createElement(DocRequestByPerson, Object.assign({}, { docs, businessUnitId, onUpload }))),
                React.createElement("div", { className: 'my-4 mb-5 mx-auto' },
                    React.createElement("p", { className: 'mb-1 font-size-15 text-center' }, "Les formats accept\u00E9s sont: "),
                    React.createElement("div", { className: 'd-flex justify-content-center pb-5' },
                        React.createElement(AcceptedFormat, { ext: '.jpeg' }, "jpeg"),
                        React.createElement(AcceptedFormat, { ext: '.png' }, "png"),
                        React.createElement(AcceptedFormat, { ext: '.pdf' }, "pdf"),
                        React.createElement(AcceptedFormat, { ext: '.tiff' }, "tiff")))),
            React.createElement("div", { className: 'container shadow p-0 bg-white', style: { marginTop: '70px', marginBottom: '70px' } },
                React.createElement("h2", { className: 'bg-primary text-center text-light py-3' }, "Fichiers charg\u00E9s "),
                React.createElement("div", { className: 'p-3' },
                    React.createElement("div", { className: 'row mx-4' },
                        React.createElement("div", { className: 'col' },
                            React.createElement(DocGroupCompleted, { completed: docs.completed }))))))));
};
const DocRequest = props => {
    const { docs, businessUnitId, onUpload } = props;
    return (React.createElement("div", { className: 'p-3' }, docs.pending.map((doc, i) => (React.createElement(React.Fragment, { key: `${doc.code}-${doc.relatedId}-${doc.relatedObjectTypeId}` },
        React.createElement(Slug, { delay: 0, from: {
                opacity: 0,
                transform: 'translate3d(-30px,-30px,0)',
            } },
            React.createElement("h4", { className: 'text-center text-primary pt-4' },
                doc.name,
                " (",
                doc.requests.length,
                ")")),
        React.createElement("div", { className: 'row justify-content-center' },
            React.createElement(Slug, { delay: 0, from: { opacity: 0, transform: 'translate3d(-40px,-60px,0)' }, className: 'col-12 col-lg-6 mb-4 pb-2' }, doc.requests.map((req, j) => (React.createElement(DocGroupCardFile, { key: `${doc.code}-${doc.relatedId}-${doc.relatedObjectTypeId}-${req.tCode}`, relatedId: doc.relatedId, relatedObjectTypeId: doc.relatedObjectTypeId, request: req, obligatory: doc.validation !== DocumentalValidationCode.NONE, businessUnitId: businessUnitId, onSuccess: onUpload }))))))))));
};
const DocRequestByPerson = props => {
    const { docs, businessUnitId, onUpload } = props;
    const relatedObjectDocs = docs.pending.reduce((acc, doc) => {
        if (!acc[doc.relatedId]) {
            acc[doc.relatedId] = [];
        }
        acc[doc.relatedId].push(doc);
        return acc;
    }, {});
    return (React.createElement("div", null, Object.keys(relatedObjectDocs).map((relatedId, i) => (React.createElement(React.Fragment, { key: relatedId },
        React.createElement("h3", { className: 'text-primary text-center' }, relatedObjectDocs[relatedId][0].objectName),
        React.createElement(DocRequest, Object.assign({}, { docs: { pending: relatedObjectDocs[relatedId], completed: [] }, businessUnitId, onUpload })))))));
};
